import React, {FC, PropsWithChildren} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {CustomError} from '../../../../../libs/shared/core/src/helpers/types/customErrors';
import {
  TagConflictWithArchivedError,
  TagDescriptionIsTooBig,
  TagHasTooManyChildren,
  TagNameExistsError,
  TagNameForbiddenError,
  TagUnnestNameForbiddenError,
} from '../../../../store/data/tags/saveTagActions';

/*
 * Props.
 */

interface TagEditorCreationErrorProps {
  error?: CustomError;
}

/*
 * Component.
 */

export const TagEditorCreationError: FC<PropsWithChildren<TagEditorCreationErrorProps>> = ({error}) => {
  if (error instanceof TagConflictWithArchivedError) {
    return <Trans id="tageditor-duplicatearchived">This tag already exists, but is archived</Trans>;
  }

  if (error instanceof TagNameExistsError) {
    return <Trans id="tageditor-duplicateerror">This tag already exists</Trans>;
  }

  if (error instanceof TagNameForbiddenError) {
    return <Trans id="tageditor-forbiddenerror">This tag name is restricted and cannot be used</Trans>;
  }

  if (error instanceof TagUnnestNameForbiddenError) {
    return (
      <Trans id="tageditor-unnest-forbiddenerror">
        This tag cannot be unnested because it has a restricted name
      </Trans>
    );
  }

  if (error instanceof TagHasTooManyChildren) {
    return <Trans id="tageditor-toomanychildren">This tag cannot accept more child tags</Trans>;
  }

  if (error instanceof TagDescriptionIsTooBig) {
    return (
      <Trans id="tageditor-descriptiontoobig">The description cannot be longer than 10,000 characters</Trans>
    );
  }

  return null;
};
